var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.title)?_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('b-row',[_c('b-col',[_c('h6',{staticClass:"mb-0"},[_vm._v(" "+_vm._s(_vm.title)+" ")])])],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }